<template>
  <v-container fluid>
    <template v-if="isRHProtegido">
      <v-row class="ml-7 mt-3" justify="start">
        <v-col cols="12">
          <v-row class="gutter-y-5">
            <v-col v-if="hasMajorityPermission" class="mt-5" cols="6" sm="4" md="3" lg="2">
              <v-hover v-slot:default="{ hover }">
                <v-card
                  @click="redirectMajority"
                  :elevation="hover ? 8 : 2"
                  class="px-5 cardMenuRHProtegido"
                  :color="hover ? 'primary-rh' : 'muted'">
                  <v-card-title class="text-h6 foreground-accent--text d-flex flex-column fill-height">
                    <v-row justify="center" align="center">
                      <v-col cols="12" align="center">
                        <v-flex>
                          <v-img
                          :color="hover ? 'foreground-accent' : 'primary-rh'"
                            height="40"
                            contain
                            :src="hover ? 'icons/majorityRhWhite.svg' : 'icons/majorityRh.svg'"
                          />
                          <h5
                            :class="
                              hover
                                ? 'foreground-accent--text mt-3 font-weight-regular'
                                : 'primary-rh--text mt-3 font-weight-regular'">
                            Maioridade
                          </h5>
                        </v-flex>
                      </v-col>
                    </v-row>
                  </v-card-title>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>

          <v-row v-if="!hasMajorityPermission && pageLoaded" align="center" justify="center" class="mt-15">
            <v-col align="center" cols="12">
            <v-row justify="center" class="mt-3">
              <v-col cols="12" md="3" lg="3" align="center">
                <v-icon large color="primary">fas fa-low-vision</v-icon>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-3">
              <v-col cols="12" md="3" lg="3" align="center">
              <p class="foreground--text label">
                Você não tem permissão para visualizar os menus.</p>
              </v-col>
            </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
    <template v-if="!isRHProtegido">
      <v-row v-if="hasMajorityPermission" justify="center" class="mt-3">
        <v-col cols="12" md="4">
          <v-btn color="primary" block outlined @click="redirectMajority">
            Maioridade
          </v-btn>
        </v-col>
      </v-row>
      <v-row v-if="!hasMajorityPermission" align="center" justify="center" class="mt-15">
        <v-col align="center" cols="12">
        <v-row justify="center" class="mt-3">
          <v-col cols="12" md="3" lg="3" align="center">
            <v-icon large color="primary">fas fa-low-vision</v-icon>
          </v-col>
        </v-row>

        <v-row justify="center" class="mt-3">
          <v-col cols="12" md="3" lg="3" align="center">
          <p class="foreground--text label">Você não tem permissão para visualizar os menus.</p>
          </v-col>
        </v-row>
        </v-col>
      </v-row>
    </template>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120">
        <div>Carregando...</div>
      </v-progress-circular>
    </v-overlay>

    <SnackbarCustomize ref="SnackbarCustomize" />
  </v-container>
</template>

<script>
import UserUtils from '@/shared/utils/user-utils';
import VerifyRoutesMixin from '@/shared/mixins/routeManagement/verifyRoutesMixin';
import PermissionService from '@/services-http/servicos/permissionService';
import SnackbarCustomize from '@/components/CustomAlerts/SnackbarCustomize.vue';
import { mapMutations } from 'vuex';

export default {
  components: {
    SnackbarCustomize,
  },

  data: () => ({
    pageLoaded: false,
    isRHProtegido: false,
    overlay: false,
    permissionService: null,
    hasMajorityServicePermission: false,
  }),

  created() {
    this.userUtils = new UserUtils();
    this.permissionService = new PermissionService();
  },

  mixins: [
    VerifyRoutesMixin,
  ],

  async beforeMount() {
    this.setOverlay(true);

    await this.permissionService.FetchPermissions()
      .then((response) => response.data)
      .then((result) => result.permissoes)
      .then((permissions) => {
        this.hasMajorityServicePermission = permissions.some((permission) => permission === 'service_majority_report');

        setTimeout(() => {
          this.pageLoaded = true;
        }, 1000);
      })
      .catch((error) => this.$refs.SnackbarCustomize.open('error', 'Ocorreu um erro ao buscar as permissões de acesso aos serviços'))
      .finally(() => this.setOverlay(false));
  },

  mounted() {
    if (this.$route.query && this.$route.query.financialGroupId) {
      sessionStorage.setItem('financialGroupId', `${this.$route.query.financialGroupId}`);
    }
    this.clearSessionStorage();
  },

  methods: {
    ...mapMutations({
      setAppOrigin: 'user-info/setAppOrigin'
    }),

    redirectMajority() {
      this.$router.push(`/majority?isRHProtegido=${this.isRHProtegido}`);
    },

    clearSessionStorage() {
      const keyTheme = 'theme';
      const keyToken = '@auth/token';
      const keyUser = '@auth/user';
      const valueTheme = sessionStorage.getItem(keyTheme);
      const valueToken = sessionStorage.getItem(keyToken);
      const valueUser = sessionStorage.getItem(keyUser);
      sessionStorage.clear();
      sessionStorage.setItem(keyTheme, valueTheme);
      sessionStorage.setItem(keyToken, valueToken);
      sessionStorage.setItem(keyUser, valueUser);
      this.setAppOrigin('PROTECTED_HR');
    },

    setOverlay(value) {
      this.overlay = value;
    },
  },

  computed: {
    hasMajorityPermission() {
      const hasAuthority = this.userUtils.hasAuthorityToAccess({ authority: 'sdi_maioridade' });

      return this.hasMajorityServicePermission && hasAuthority;
    },
  }
};
</script>

<style scoped>
  .v-card {
    transition: opacity .4s ease-in-out;
  }
  .cardMenuRHProtegido {
    height: 190px;
    width: 200px;
    cursor: pointer;
    border-radius: 15px;
  }
</style>
